import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../utils/propUtils';
var VeltCommentDialogAgentSuggestionAuthorAvatarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-agent-suggestion-author-avatar-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentDialogAgentSuggestionAuthorAvatarWireframe;
